import React from 'react';
import { Link } from 'react-router-dom';
import { activityUserId } from './countryCentroids';

export default function SessionMetricsPanel({ sessions, variant = 'cards' }) {
  const onlineNow = sessions?.onlineNow || 0;
  const avgDuration = sessions?.avgDurationMinutes || 0;
  const today = sessions?.todayCount ?? sessions?.sessionsToday ?? 0;
  const total = sessions?.totalSessions || 0;

  if (variant === 'list') {
    return (
      <div className="chart">
        <h2>Session Metrics</h2>
        <div className="session-stats">
          <div className="session-stat">
            <span className="label">Online Now:</span>
            <span className="value">{onlineNow}</span>
          </div>
          <div className="session-stat">
            <span className="label">Avg Duration:</span>
            <span className="value">{avgDuration} min</span>
          </div>
          <div className="session-stat">
            <span className="label">Sessions Today:</span>
            <span className="value">{today}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="metrics-grid">
      <div className="metric-item">
        <span className="metric-value">{onlineNow}</span>
        <span className="metric-label">Online Now</span>
      </div>
      <div className="metric-item">
        <span className="metric-value">{avgDuration}</span>
        <span className="metric-label">Avg Duration (min)</span>
      </div>
      <div className="metric-item">
        <span className="metric-value">{today}</span>
        <span className="metric-label">Sessions Today</span>
      </div>
      {variant === 'full' ? (
        <div className="metric-item">
          <span className="metric-value">{total}</span>
          <span className="metric-label">Total Sessions</span>
        </div>
      ) : null}
    </div>
  );
}

function ActivityRow({ item, kind, index }) {
  const userId = activityUserId(item);
  const email = item.user?.email || item.email || 'Unknown';
  const when = item.loginAt || item.createdAt;
  const label = kind === 'registration'
    ? `${email} ${item.isVerified ? '(Verified)' : '(Pending)'}`
    : email;
  const inner = (
    <>
      <span>{label}</span>
      <span>{when ? new Date(when).toLocaleString() : ''}</span>
    </>
  );
  const key = `${userId || email}-${when || index}`;
  if (!userId) {
    return <div key={key} className="activity-item">{inner}</div>;
  }
  return (
    <Link key={key} to={`/admin/users?user=${encodeURIComponent(userId)}`} className="activity-item activity-item-link">
      {inner}
    </Link>
  );
}

export function RecentActivityGrid({ recentActivity, loginLimit = 5, registrationLimit = 5 }) {
  if (!recentActivity) return null;
  const logins = recentActivity.recentLogins || [];
  const registrations = recentActivity.recentRegistrations || [];
  if (!logins.length && !registrations.length) return null;

  return (
    <div className="activity-section">
      <h2>Recent Activity</h2>
      <div className="activity-grid">
        {logins.length ? (
          <div className="activity-card">
            <h3>Recent Logins</h3>
            {logins.slice(0, loginLimit).map((login, index) => (
              <ActivityRow key={`${activityUserId(login) || login.user?.email}-${login.loginAt || index}`} item={login} kind="login" index={index} />
            ))}
          </div>
        ) : null}

        {registrations.length ? (
          <div className="activity-card">
            <h3>Recent Registrations</h3>
            {registrations.slice(0, registrationLimit).map((user, index) => (
              <ActivityRow key={`${activityUserId(user) || user.email}-${user.createdAt || index}`} item={user} kind="registration" index={index} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
